import { useCallback } from 'react';
import useLocalStore from '../../../hooks/useLocalStore';
import FJMobileFaceSwapSecond from './FJMobileFaceSwapSecond';
import { useDispatch, useSelector } from 'react-redux';
import { setSliceMobileStep } from '../../../redux/slices/FJSliceFaceSwap';
import FJActionFaceSwap from '../../../redux/action/FJActionFaceSwap';
import FJActionModal from '../../../redux/action/FJActionModal';

const FJMobileFaceSwapSecondContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const mobileStep = useSelector(state => state.faceSwap.mobileStep);
    const originUploadImageInfo = useSelector(state => state.faceSwap.originUploadImageInfo);
    const onNextClick = useCallback(() => {
        dispatch(setSliceMobileStep(2));
    }, [dispatch]);
    const _onUploadOriginImage = useCallback(
        file => {
            dispatch(FJActionFaceSwap.uploadOriginImageAction(file));
        },
        [dispatch],
    );
    const simplePreview = useCallback(
        data => {
            dispatch(FJActionModal.showMobileSimplePreviewModalAction(data));
        },
        [dispatch],
    );
    return (
        <FJMobileFaceSwapSecond
            active={mobileStep === 1}
            onNextClick={onNextClick}
            onUploadOriginImage={_onUploadOriginImage}
            originUploadImageInfo={originUploadImageInfo}
            simplePreview={simplePreview}
        />
    );
};

export default FJMobileFaceSwapSecondContainer;
